import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getCategoryMedia } from "@/lib/mediaQuery";

export default function CategoryEntry() {
  return (
    <section className="w-full px-4 md:px-6 -mt-8 md:-mt-12 relative z-20">
      <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((c) => {
            const count = getCategoryMedia(c.slug).length;
            return (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="group flex items-center gap-3 p-3 md:p-4 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors"
              >
                <span className="w-11 h-11 rounded-md bg-primary-500 text-background-50 flex items-center justify-center shrink-0 group-hover:bg-accent-500 group-hover:text-foreground-950 transition-colors">
                  <i className={`${c.icon} text-xl`}></i>
                </span>
                <span className="min-w-0">
                  <span className="block font-heading text-sm md:text-base font-bold text-foreground-900">{c.name}</span>
                  <span className="block text-xs text-foreground-500 mt-0.5">{count} 部内容</span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}